/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  conversations: {
    options: {
      java_package: "com.appunite.chat.model.conversations",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      CreateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 2
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 3
          }
        }
      },
      UpdateConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      DeleteConversationServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      CreateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          metadata: {
            rule: "required",
            type: "ConversationMetadata",
            id: 2
          }
        }
      },
      CreateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      UpdateConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          groupMetadata: {
            rule: "required",
            type: "GroupConversationMetadata",
            id: 4
          }
        }
      },
      UpdateConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      DeleteConversationClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          isGroup: {
            rule: "required",
            type: "bool",
            id: 3
          }
        }
      },
      DeleteConversationConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          }
        }
      },
      ConversationMetadata: {
        oneofs: {
          type: {
            oneof: [
              "groupMetadata",
              "singleMetadata"
            ]
          }
        },
        fields: {
          groupMetadata: {
            type: "GroupConversationMetadata",
            id: 1
          },
          singleMetadata: {
            type: "SingleConversationMetadata",
            id: 2
          }
        }
      },
      GroupConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          avatar: {
            type: "string",
            id: 2
          },
          name: {
            rule: "required",
            type: "string",
            id: 3
          },
          creatorId: {
            rule: "required",
            type: "string",
            id: 4
          },
          adminIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          externalMetadata: {
            type: "bytes",
            id: 6
          }
        }
      },
      SingleConversationMetadata: {
        fields: {
          participantsIds: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  messages: {
    options: {
      java_package: "com.appunite.chat.model.messages",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      CreateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      UpdateMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 3
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 4
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 5
          },
          likedUserIds: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      DeleteMessageServerMessage: {
        fields: {
          messageId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      CreateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      CreateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          createdAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          }
        }
      },
      CreateMessageNeedToBeDeletedConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      DeleteMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          retract: {
            rule: "required",
            type: "bool",
            id: 4
          }
        }
      },
      DeleteMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          developerInfoMessageDeletionWasFaked: {
            type: "bool",
            id: 3
          }
        }
      },
      UpdateMessageClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 3
          },
          body: {
            rule: "required",
            type: "BodyTypes",
            id: 4
          }
        }
      },
      UpdateMessageConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      },
      BodyTypes: {
        oneofs: {
          body: {
            oneof: [
              "text",
              "blobText",
              "ping",
              "image",
              "location",
              "attachment",
              "contact",
              "timelineForward",
              "groupEvent",
              "superuserProfile",
              "superuserPost",
              "call",
              "video",
              "audio",
              "adminGroupEvent",
              "sticker",
              "storyItemReply"
            ]
          }
        },
        fields: {
          quotedMessage: {
            type: "QuotedMessage",
            id: 30
          },
          text: {
            type: "Text",
            id: 10
          },
          blobText: {
            type: "BlobText",
            id: 11
          },
          ping: {
            type: "Ping",
            id: 16
          },
          image: {
            type: "Image",
            id: 17
          },
          location: {
            type: "Location",
            id: 18
          },
          attachment: {
            type: "Attachment",
            id: 19
          },
          contact: {
            type: "Contact",
            id: 20
          },
          timelineForward: {
            type: "TimelineForward",
            id: 21
          },
          groupEvent: {
            type: "GroupEvent",
            id: 22
          },
          superuserProfile: {
            type: "UserProfile",
            id: 23
          },
          superuserPost: {
            type: "UserPost",
            id: 24
          },
          call: {
            type: "Call",
            id: 25
          },
          video: {
            type: "Video",
            id: 26
          },
          audio: {
            type: "Audio",
            id: 27
          },
          adminGroupEvent: {
            type: "AdminGroupEvent",
            id: 28
          },
          sticker: {
            type: "Sticker",
            id: 29
          },
          storyItemReply: {
            type: "StoryItemReply",
            id: 40
          }
        },
        nested: {
          QuotedMessage: {
            fields: {
              messageId: {
                type: "bytes",
                id: 1
              },
              actorId: {
                type: "string",
                id: 2
              },
              createdAtMillis: {
                type: "uint64",
                id: 3
              },
              body: {
                type: "BodyTypes",
                id: 4
              }
            }
          },
          Text: {
            fields: {
              body: {
                rule: "required",
                type: "string",
                id: 1
              },
              linkPreview: {
                type: "LinkPreview",
                id: 2
              },
              mentions: {
                rule: "repeated",
                type: "Mention",
                id: 3
              }
            }
          },
          LinkPreview: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              websiteUrl: {
                type: "string",
                id: 3
              },
              originalUrl: {
                type: "string",
                id: 4
              },
              description: {
                type: "string",
                id: 5
              }
            }
          },
          Mention: {
            fields: {
              actorId: {
                type: "string",
                id: 1
              },
              location: {
                type: "uint32",
                id: 2
              },
              length: {
                type: "uint32",
                id: 3
              }
            }
          },
          Sticker: {
            fields: {
              stickerUrl: {
                type: "string",
                id: 1
              },
              stickerWidth: {
                type: "uint32",
                id: 2
              },
              stickerHeight: {
                type: "uint32",
                id: 3
              },
              stickerId: {
                type: "string",
                id: 4
              }
            }
          },
          BlobText: {
            fields: {
              teaser: {
                rule: "required",
                type: "string",
                id: 1
              },
              fileUrl: {
                type: "string",
                id: 2
              }
            }
          },
          StoryItemReply: {
            oneofs: {
              body: {
                oneof: [
                  "image",
                  "video"
                ]
              }
            },
            fields: {
              storyId: {
                type: "string",
                id: 1
              },
              storyItemId: {
                type: "string",
                id: 2
              },
              replyBody: {
                type: "string",
                id: 3
              },
              image: {
                type: "Image",
                id: 6
              },
              video: {
                type: "Video",
                id: 7
              }
            },
            nested: {
              Image: {
                fields: {
                  imageUrl: {
                    type: "string",
                    id: 1
                  },
                  imageWidth: {
                    type: "int32",
                    id: 2
                  },
                  imageHeight: {
                    type: "int32",
                    id: 3
                  }
                }
              },
              Video: {
                fields: {
                  videoUrl: {
                    type: "string",
                    id: 1
                  },
                  mimeType: {
                    type: "string",
                    id: 2
                  },
                  imageWidth: {
                    type: "int32",
                    id: 3
                  },
                  imageHeight: {
                    type: "int32",
                    id: 4
                  },
                  imageUrl: {
                    type: "string",
                    id: 5
                  },
                  videoDuration: {
                    type: "int32",
                    id: 6
                  }
                }
              }
            }
          },
          Ping: {
            fields: {}
          },
          Video: {
            fields: {
              videoUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 3
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 4
              },
              imageUrl: {
                type: "string",
                id: 5
              },
              progress: {
                type: "float",
                id: 6
              },
              imageColor: {
                type: "int32",
                id: 7
              },
              imageData: {
                type: "bytes",
                id: 8
              }
            }
          },
          Image: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              imageWidth: {
                rule: "required",
                type: "int32",
                id: 2
              },
              imageHeight: {
                rule: "required",
                type: "int32",
                id: 3
              },
              OBSOLETEThumbImageUrl: {
                type: "string",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              imageColor: {
                type: "int32",
                id: 6
              },
              imageData: {
                type: "bytes",
                id: 7
              }
            }
          },
          Location: {
            fields: {
              latitude: {
                rule: "required",
                type: "float",
                id: 1
              },
              longitude: {
                rule: "required",
                type: "float",
                id: 2
              }
            }
          },
          Attachment: {
            fields: {
              fileUrl: {
                type: "string",
                id: 1
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 2
              },
              fileSize: {
                type: "uint64",
                id: 4
              },
              progress: {
                type: "float",
                id: 5
              },
              fileName: {
                type: "string",
                id: 6
              }
            }
          },
          Contact: {
            fields: {
              phoneNumber: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                rule: "required",
                type: "string",
                id: 3
              }
            }
          },
          TimelineForward: {
            fields: {
              timelineId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserProfile: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          UserPost: {
            fields: {
              postId: {
                rule: "required",
                type: "string",
                id: 1
              }
            }
          },
          GroupEvent: {
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 2
              },
              targetUserId: {
                rule: "required",
                type: "string",
                id: 3
              }
            },
            nested: {
              Type: {
                values: {
                  CHAT_CREATED_ACTION: 0,
                  USER_LEFT_ACTION: 2,
                  USER_ADDED_ACTION: 1,
                  USER_REMOVED_ACTION: 3
                }
              }
            }
          },
          AdminGroupEvent: {
            fields: {
              type: {
                type: "Type",
                id: 1
              },
              targetUserId: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Type: {
                values: {
                  ADMIN_UNKNOWN_ACTION: 0,
                  ADMIN_ADDED_ACTION: 1,
                  ADMIN_REMOVED_ACTION: 2
                }
              }
            }
          },
          Call: {
            oneofs: {
              status: {
                oneof: [
                  "success",
                  "cancelled",
                  "noAnswer",
                  "denied"
                ]
              }
            },
            fields: {
              type: {
                rule: "required",
                type: "Type",
                id: 1
              },
              success: {
                type: "Success",
                id: 2
              },
              cancelled: {
                type: "Cancelled",
                id: 3
              },
              noAnswer: {
                type: "NoAnswer",
                id: 4
              },
              denied: {
                type: "Denied",
                id: 5
              },
              callId: {
                type: "string",
                id: 6
              }
            },
            nested: {
              Type: {
                values: {
                  VIDEO: 0,
                  VOICE: 1
                }
              },
              Success: {
                fields: {
                  callTimeInMillis: {
                    rule: "required",
                    type: "uint64",
                    id: 1
                  }
                }
              },
              Cancelled: {
                fields: {}
              },
              NoAnswer: {
                fields: {}
              },
              Denied: {
                fields: {}
              }
            }
          },
          Audio: {
            fields: {
              audioUrl: {
                type: "string",
                id: 1
              },
              durationInMillis: {
                rule: "required",
                type: "uint64",
                id: 2
              },
              mimeType: {
                rule: "required",
                type: "string",
                id: 3
              },
              progress: {
                type: "float",
                id: 4
              }
            }
          }
        }
      }
    }
  },
  messages_statuses: {
    options: {
      java_package: "com.appunite.chat.model.statuses",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      ConversationReceiptServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          actorId: {
            rule: "required",
            type: "string",
            id: 2
          },
          latestDeliveredMessageCreatedAtMillis: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 4
          },
          unreadMessagesCount: {
            type: "uint64",
            id: 5,
            options: {
              "default": 0
            }
          }
        }
      },
      CurrentUserUnreadMessagesServerMessage: {
        fields: {
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          unreadMessagesCount: {
            rule: "required",
            type: "uint64",
            id: 3
          },
          latestReadMessageCreatedAtMillis: {
            type: "uint64",
            id: 5
          }
        }
      },
      UpdateConversationDeliveredClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadClientMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          conversationId: {
            rule: "required",
            type: "bytes",
            id: 2
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 3
          }
        }
      },
      UpdateConversationReadConfirmationServerMessage: {
        fields: {
          transactionId: {
            rule: "required",
            type: "bytes",
            id: 1
          },
          messageId: {
            rule: "required",
            type: "bytes",
            id: 2
          }
        }
      }
    }
  },
  rpc: {
    options: {
      java_package: "com.appunite.chat.model.rpc",
      java_multiple_files: true,
      "(.google.protobuf.objectivec_file_options).class_prefix": "KCP",
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      RpcGetAllConversationsServerResponse: {
        fields: {
          nextSynchronizationToken: {
            rule: "required",
            type: "string",
            id: 1
          },
          currentUserIdentifier: {
            rule: "required",
            type: "string",
            id: 2
          },
          conversations: {
            rule: "repeated",
            type: "ConversationWithLastMessage",
            id: 3
          }
        }
      },
      ConversationWithLastMessage: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          lastMessage: {
            type: "messages.CreateMessageServerMessage",
            id: 2
          },
          messagesStatuses: {
            rule: "repeated",
            type: "messages_statuses.ConversationReceiptServerMessage",
            id: 3
          },
          currentUserMessagesStatuses: {
            type: "messages_statuses.CurrentUserUnreadMessagesServerMessage",
            id: 4
          }
        }
      },
      RpcGetMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMore: {
            rule: "required",
            type: "bool",
            id: 2
          }
        }
      },
      RpcGetMessagesDeltaServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          hasMoreOlderMessages: {
            type: "bool",
            id: 2
          },
          hasMoreNewerMessages: {
            type: "bool",
            id: 3
          }
        }
      },
      RpcGetAllBlockedUsersServerResponse: {
        fields: {
          users: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      RpcStarMessageServerResponse: {
        fields: {}
      },
      RpcUnstarMessageServerResponse: {
        fields: {}
      },
      RpcGetAllStarredConversationsServerResponse: {
        fields: {
          conversations: {
            rule: "repeated",
            type: "ConversationWithStarredMessageIds",
            id: 1
          },
          nextToken: {
            type: "string",
            id: 2
          }
        }
      },
      ConversationWithStarredMessageIds: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          },
          messageIds: {
            rule: "repeated",
            type: "bytes",
            id: 2
          }
        }
      },
      RpcGetAllStarredMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          }
        }
      },
      RpcLikeMessageServerResponse: {
        fields: {}
      },
      RpcDislikeMessageServerResponse: {
        fields: {}
      },
      RpcSendMessageClientRequest: {
        fields: {
          body: {
            rule: "required",
            type: "messages.BodyTypes",
            id: 1
          }
        }
      },
      RpcSendMessageServerResponse: {
        fields: {}
      },
      RpcConversationJoinLinkServerResponse: {
        fields: {
          conversationId: {
            type: "bytes",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      RpcJoinConversationMetadataServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcJoinConversationClientRequest: {
        fields: {
          joinLink: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      RpcJoinConversationServerResponse: {
        fields: {
          conversation: {
            rule: "required",
            type: "conversations.CreateConversationServerMessage",
            id: 1
          }
        }
      },
      RpcSearchMessagesServerResponse: {
        fields: {
          messages: {
            rule: "repeated",
            type: "messages.CreateMessageServerMessage",
            id: 1
          },
          conversations: {
            rule: "repeated",
            type: "conversations.CreateConversationServerMessage",
            id: 2
          },
          nextToken: {
            type: "string",
            id: 3
          }
        }
      }
    }
  },
  authentication: {
    nested: {
      SignUpRequest: {
        oneofs: {
          method: {
            oneof: [
              "email",
              "phone",
              "facebook"
            ]
          }
        },
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          email: {
            type: "EmailSignUpData",
            id: 3
          },
          phone: {
            type: "PhoneSignUpData",
            id: 4
          },
          facebook: {
            type: "FacebookSignUpData",
            id: 5
          }
        },
        nested: {
          EmailSignUpData: {
            fields: {
              email: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              username: {
                type: "string",
                id: 3
              },
              password: {
                type: "string",
                id: 4
              }
            }
          },
          PhoneSignUpData: {
            fields: {
              countryCode: {
                type: "string",
                id: 1
              },
              phone: {
                type: "string",
                id: 2
              },
              name: {
                type: "string",
                id: 3
              },
              username: {
                type: "string",
                id: 4
              },
              password: {
                type: "string",
                id: 5
              },
              firebaseToken: {
                type: "string",
                id: 6
              }
            }
          },
          FacebookSignUpData: {
            fields: {
              facebookToken: {
                type: "string",
                id: 1
              }
            }
          }
        }
      },
      SignUpResponse: {
        oneofs: {
          response: {
            oneof: [
              "token",
              "unconfirmed"
            ]
          }
        },
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          },
          unconfirmed: {
            type: "ConfirmationRequired",
            id: 2
          }
        },
        nested: {
          ConfirmationRequired: {
            fields: {
              message: {
                type: "string",
                id: 1
              }
            }
          }
        }
      },
      SignUpError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2,
              VALIDATION_FAILED: 3,
              FB_CONNECTION_FAILURE: 4,
              FIREBASE_AUTH_ERROR: 5,
              FACEBOOK_ID_ALREADY_TAKEN: 6
            }
          }
        }
      },
      LogInRequest: {
        oneofs: {
          method: {
            oneof: [
              "email",
              "phone",
              "facebook",
              "username",
              "firebaseAuth"
            ]
          }
        },
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          email: {
            type: "EmailLogInData",
            id: 3
          },
          phone: {
            type: "PhoneLogInData",
            id: 4
          },
          facebook: {
            type: "FacebookLogInData",
            id: 5
          },
          username: {
            type: "UsernameLogInData",
            id: 6
          },
          firebaseAuth: {
            type: "FirebaseAuthLogInData",
            id: 7
          }
        },
        nested: {
          EmailLogInData: {
            fields: {
              email: {
                type: "string",
                id: 1
              },
              password: {
                type: "string",
                id: 2
              }
            }
          },
          PhoneLogInData: {
            fields: {
              phoneNumber: {
                type: "string",
                id: 1
              },
              password: {
                type: "string",
                id: 2
              }
            }
          },
          FacebookLogInData: {
            fields: {
              facebookToken: {
                type: "string",
                id: 1
              }
            }
          },
          UsernameLogInData: {
            fields: {
              username: {
                type: "string",
                id: 2
              },
              password: {
                type: "string",
                id: 3
              }
            }
          },
          FirebaseAuthLogInData: {
            fields: {
              phoneNumber: {
                type: "string",
                id: 1
              },
              firebaseToken: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      LogInResponse: {
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          }
        }
      },
      LogInError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2,
              INVALID_EMAIL_AUTHENTICATION: 3,
              INVALID_PHONE_AUTHENTICATION: 4,
              INVALID_FACEBOOK_AUTHENTICATION: 5,
              INVALID_USERNAME_AUTHENTICATION: 6,
              UNCONFIRMED_USER: 7,
              FB_CONNECTION_FAILURE: 8,
              UNKNOWN_PHONE_NUMBER: 9,
              FIREBASE_AUTH_ERROR: 10
            }
          }
        }
      },
      LegacyTokensResponse: {
        fields: {
          xAuthToken: {
            type: "string",
            id: 1
          }
        }
      },
      TokenUpgradeRequest: {
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          scopes: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TokenUpgradeResponse: {
        fields: {
          token: {
            type: "com.newmedia.auth.model.TokenResponse",
            id: 1
          }
        }
      },
      TokenUpgradeError: {
        fields: {
          code: {
            type: "ErrorCode",
            id: 1
          },
          message: {
            type: "string",
            id: 2
          }
        },
        nested: {
          ErrorCode: {
            values: {
              UNKNOWN: 0,
              PERFORMED_BY_UNAUTHORIZED_APP: 1,
              UNAVAILABLE_SCOPE_REQUESTED: 2
            }
          }
        }
      },
      RecoverPasswordRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      RecoverPasswordResponse: {
        fields: {}
      },
      CountryCode: {
        fields: {
          countryCode: {
            type: "string",
            id: 1
          }
        }
      },
      ResendEmailRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      ResendEmailResponse: {
        fields: {}
      }
    }
  },
  com: {
    nested: {
      newmedia: {
        nested: {
          auth: {
            nested: {
              model: {
                nested: {
                  ApplicationRequest: {
                    fields: {
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    }
                  },
                  ApplicationResponse: {
                    fields: {
                      applicationName: {
                        type: "string",
                        id: 1
                      },
                      applicationUrl: {
                        type: "string",
                        id: 2
                      },
                      applicationAuthenticated: {
                        type: "bool",
                        id: 3
                      }
                    }
                  },
                  ApplicationError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  AuthRequest: {
                    fields: {
                      scope: {
                        rule: "repeated",
                        type: "string",
                        id: 1
                      },
                      responseType: {
                        type: "ResponseType",
                        id: 2
                      },
                      applicationData: {
                        type: "ApplicationData",
                        id: 4
                      }
                    },
                    nested: {
                      ResponseType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1
                        }
                      }
                    }
                  },
                  AuthResponse: {
                    fields: {
                      code: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  AuthError: {
                    fields: {
                      code: {
                        type: "ErrorCode",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      ErrorCode: {
                        values: {
                          UNKNOWN: 0,
                          WRONG_APPLICATION_DATA: 1
                        }
                      }
                    }
                  },
                  TokenRequest: {
                    fields: {
                      clientId: {
                        type: "string",
                        id: 1
                      },
                      grantType: {
                        type: "GrantType",
                        id: 2
                      },
                      code: {
                        type: "string",
                        id: 3
                      },
                      refreshToken: {
                        type: "string",
                        id: 4
                      }
                    },
                    nested: {
                      GrantType: {
                        values: {
                          UNKNOWN: 0,
                          CODE: 1,
                          REFRESH_TOKEN: 2
                        }
                      }
                    }
                  },
                  TokenResponse: {
                    fields: {
                      accessToken: {
                        type: "string",
                        id: 1
                      },
                      expiresInMillis: {
                        type: "uint32",
                        id: 2
                      },
                      refreshToken: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  TokenError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          LOGGED_OUT: 1
                        }
                      }
                    }
                  },
                  CertsResponse: {
                    fields: {
                      certificates: {
                        rule: "repeated",
                        type: "Certificate",
                        id: 1
                      }
                    },
                    nested: {
                      Certificate: {
                        fields: {
                          kid: {
                            type: "string",
                            id: 1
                          },
                          pemCertificate: {
                            type: "string",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  ApplicationData: {
                    oneofs: {
                      applicationData: {
                        oneof: [
                          "ios",
                          "android"
                        ]
                      }
                    },
                    fields: {
                      ios: {
                        type: "Ios",
                        id: 1
                      },
                      android: {
                        type: "Android",
                        id: 2
                      }
                    },
                    nested: {
                      Ios: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          redirectUri: {
                            type: "string",
                            id: 2
                          },
                          applicationBundleId: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      Android: {
                        fields: {
                          clientId: {
                            type: "string",
                            id: 1
                          },
                          packageName: {
                            type: "string",
                            id: 2
                          },
                          applicationSignatureSha1: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          conference: {
            nested: {
              model: {
                nested: {
                  PutBuyRequest: {
                    oneofs: {
                      subscription: {
                        oneof: [
                          "androidSubscription",
                          "iosSubscription"
                        ]
                      }
                    },
                    fields: {
                      force: {
                        type: "bool",
                        id: 2
                      },
                      androidSubscription: {
                        type: "AndroidSubscription",
                        id: 3
                      },
                      iosSubscription: {
                        type: "IosSubscription",
                        id: 4
                      }
                    },
                    nested: {
                      AndroidSubscription: {
                        fields: {
                          packageName: {
                            type: "string",
                            id: 3
                          },
                          productId: {
                            type: "string",
                            id: 1
                          },
                          token: {
                            type: "string",
                            id: 2
                          }
                        }
                      },
                      IosSubscription: {
                        fields: {
                          productId: {
                            type: "string",
                            id: 1
                          },
                          receipt: {
                            type: "string",
                            id: 2
                          },
                          password: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  },
                  PutBuyResponse: {
                    fields: {
                      subscrption: {
                        type: "Subscription",
                        id: 1
                      }
                    }
                  },
                  PutBuyError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          ASIGNED_TO_OTHER_USER: 1,
                          ANDROID_WRONG_SUBSCRIPTION_ID: 2,
                          ANDROID_WRONG_TOKEN: 3
                        }
                      }
                    }
                  },
                  BuyResponse: {
                    fields: {
                      subscription: {
                        type: "Subscription",
                        id: 1
                      }
                    }
                  },
                  BuyError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  Subscription: {
                    fields: {
                      active: {
                        type: "bool",
                        id: 1
                      },
                      expireTimeMillis: {
                        type: "uint64",
                        id: 2
                      },
                      autoRenewing: {
                        type: "bool",
                        id: 3
                      }
                    }
                  },
                  CallChannel: {
                    fields: {
                      topic: {
                        type: "string",
                        id: 1
                      },
                      event: {
                        type: "string",
                        id: 2
                      },
                      payload: {
                        type: "CallPayload",
                        id: 3
                      },
                      reference: {
                        type: "string",
                        id: 4
                      }
                    }
                  },
                  CallPayload: {
                    oneofs: {
                      message: {
                        oneof: [
                          "participantsCount"
                        ]
                      }
                    },
                    fields: {
                      participantsCount: {
                        type: "ParticipantsCountResponses",
                        id: 1
                      }
                    },
                    nested: {
                      ParticipantsCountResponses: {
                        oneofs: {
                          message: {
                            oneof: [
                              "update",
                              "error"
                            ]
                          }
                        },
                        fields: {
                          update: {
                            type: "ParticipantsCountUpdate",
                            id: 1
                          },
                          error: {
                            type: "Error",
                            id: 2
                          }
                        },
                        nested: {
                          ParticipantsCountUpdate: {
                            fields: {
                              count: {
                                type: "uint32",
                                id: 3
                              }
                            }
                          },
                          Error: {
                            fields: {
                              code: {
                                type: "Code",
                                id: 1
                              },
                              userMessage: {
                                type: "string",
                                id: 2
                              }
                            },
                            nested: {
                              Code: {
                                values: {
                                  UNKNOWN: 0,
                                  ERROR_YOU_ARE_NOT_AN_ADMIN: 1
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  CreateSlotRequest: {
                    fields: {
                      username: {
                        type: "string",
                        id: 1
                      },
                      pin: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  CreateSlotResponse: {
                    fields: {
                      slotId: {
                        type: "string",
                        id: 1
                      },
                      iceServers: {
                        rule: "repeated",
                        type: "IceServer",
                        id: 2
                      },
                      chatChannelName: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  CreateSlotError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          INCORRECT_URL_OR_PIN: 1,
                          ROOM_LOCKED: 2,
                          NO_MORE_SLOTS: 3
                        }
                      }
                    }
                  },
                  PutAdminRequest: {
                    fields: {
                      isAdmin: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  PutAdminResponse: {
                    fields: {}
                  },
                  PutAdminError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1,
                          YOU_CAN_CHANGE_RIGHTS_TO_OWNER: 2,
                          USER_IS_NOT_IN_CALL: 3
                        }
                      }
                    }
                  },
                  MuteRequest: {
                    fields: {
                      mute: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  MuteResponse: {
                    fields: {}
                  },
                  MuteError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1
                        }
                      }
                    }
                  },
                  LockRequest: {
                    fields: {
                      lock: {
                        type: "bool",
                        id: 1
                      }
                    }
                  },
                  LockResponse: {
                    fields: {}
                  },
                  LockError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  TitleRequest: {
                    fields: {
                      title: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  TitleResponse: {
                    fields: {}
                  },
                  TitleError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  MuteAllRequest: {
                    fields: {}
                  },
                  MuteAllResponse: {
                    fields: {}
                  },
                  MuteAllError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  MuteUserRequest: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  MuteUserResponse: {
                    fields: {}
                  },
                  MuteUserError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1
                        }
                      }
                    }
                  },
                  KickUserRequest: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  KickUserResponse: {
                    fields: {}
                  },
                  KickUserError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_AN_ADMIN: 1,
                          ADMIN_CANT_KICK_ADMIN: 2
                        }
                      }
                    }
                  },
                  EndConferenceRequest: {
                    fields: {}
                  },
                  EndConferenceResponse: {
                    fields: {}
                  },
                  EndConferenceError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  EndSlotRequest: {
                    fields: {
                      reason: {
                        type: "Reason",
                        id: 1
                      },
                      clientMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Reason: {
                        values: {
                          UNKNOWN: 0,
                          USER_REQUESTED_END: 1,
                          WEBRTC_INITIALIZATION_ERROR: 2
                        }
                      }
                    }
                  },
                  EndSlotResponse: {
                    fields: {}
                  },
                  EndSlotError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0
                        }
                      }
                    }
                  },
                  ConnectResponses: {
                    oneofs: {
                      message: {
                        oneof: [
                          "slotEnded",
                          "pong",
                          "webrtcMessage",
                          "updateStatus",
                          "adminMutedAllParticipants",
                          "updateCredentials",
                          "receivedAdminRights"
                        ]
                      }
                    },
                    fields: {
                      slotEnded: {
                        type: "SlotEnded",
                        id: 1
                      },
                      pong: {
                        type: "PongMessage",
                        id: 2
                      },
                      webrtcMessage: {
                        type: "WebrtcMessage",
                        id: 3
                      },
                      updateStatus: {
                        type: "UpdateStatus",
                        id: 4
                      },
                      adminMutedAllParticipants: {
                        type: "AdminMutedAllParticipants",
                        id: 5
                      },
                      updateCredentials: {
                        type: "UpdateCredentials",
                        id: 6
                      },
                      receivedAdminRights: {
                        type: "ReceivedAdminRights",
                        id: 16
                      }
                    },
                    nested: {
                      UpdateStatus: {
                        fields: {
                          participants: {
                            rule: "repeated",
                            type: "Participant",
                            id: 1
                          },
                          title: {
                            type: "string",
                            id: 2
                          },
                          locked: {
                            type: "bool",
                            id: 3
                          },
                          started: {
                            type: "bool",
                            id: 4
                          },
                          ownerUserId: {
                            type: "string",
                            id: 5
                          },
                          connectedUserId: {
                            type: "string",
                            id: 6
                          },
                          freeCall: {
                            type: "bool",
                            id: 7
                          }
                        },
                        nested: {
                          Participant: {
                            fields: {
                              userId: {
                                type: "string",
                                id: 1
                              },
                              isAdmin: {
                                type: "bool",
                                id: 2
                              },
                              isMuted: {
                                type: "bool",
                                id: 3
                              },
                              isOnline: {
                                type: "bool",
                                id: 4
                              },
                              isTalking: {
                                type: "bool",
                                id: 5
                              }
                            }
                          }
                        }
                      },
                      SlotEnded: {
                        fields: {
                          code: {
                            type: "Code",
                            id: 1
                          },
                          userMessage: {
                            type: "string",
                            id: 2
                          },
                          callDurationInMillis: {
                            type: "uint64",
                            id: 3
                          }
                        },
                        nested: {
                          Code: {
                            values: {
                              UNKNOWN: 0,
                              CALL_ENDED_BY_ADMINISTRATOR: 1,
                              YOU_WERE_KICKED: 2,
                              USER_REQUESTED_END: 3,
                              WEBRTC_INITIALIZATION_ERROR: 5
                            }
                          }
                        }
                      },
                      PongMessage: {
                        fields: {
                          data: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      WebrtcMessage: {
                        fields: {
                          sequence: {
                            type: "uint32",
                            id: 1
                          },
                          data: {
                            type: "DataMessage",
                            id: 2
                          }
                        }
                      },
                      AdminMutedAllParticipants: {
                        fields: {
                          whoUserId: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      ReceivedAdminRights: {
                        fields: {
                          whoUserId: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      UpdateCredentials: {
                        fields: {
                          username: {
                            type: "string",
                            id: 1
                          },
                          conferenceUrl: {
                            type: "string",
                            id: 2
                          },
                          conferencePin: {
                            type: "string",
                            id: 3
                          }
                        }
                      }
                    }
                  },
                  ConnectRequests: {
                    oneofs: {
                      message: {
                        oneof: [
                          "ping",
                          "webrtcMessage",
                          "speaking"
                        ]
                      }
                    },
                    fields: {
                      ping: {
                        type: "PingMessage",
                        id: 1
                      },
                      webrtcMessage: {
                        type: "WebrtcMessage",
                        id: 2
                      },
                      speaking: {
                        type: "SpeakingMessage",
                        id: 3
                      }
                    },
                    nested: {
                      PingMessage: {
                        fields: {
                          data: {
                            type: "string",
                            id: 1
                          }
                        }
                      },
                      SpeakingMessage: {
                        fields: {
                          speaking: {
                            type: "bool",
                            id: 1
                          }
                        }
                      },
                      WebrtcMessage: {
                        fields: {
                          sequence: {
                            type: "uint32",
                            id: 1
                          },
                          data: {
                            type: "DataMessage",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  IceServer: {
                    fields: {
                      uri: {
                        type: "string",
                        id: 1
                      },
                      username: {
                        type: "string",
                        id: 2
                      },
                      password: {
                        type: "string",
                        id: 3
                      }
                    }
                  },
                  DataMessage: {
                    oneofs: {
                      data: {
                        oneof: [
                          "sessionsDescription",
                          "iceCandidateAdd",
                          "iceCandidateRemoved"
                        ]
                      }
                    },
                    fields: {
                      sessionsDescription: {
                        type: "SessionDescription",
                        id: 1
                      },
                      iceCandidateAdd: {
                        type: "IceCandidateAdd",
                        id: 2
                      },
                      iceCandidateRemoved: {
                        type: "IceCandidateRemoved",
                        id: 3
                      }
                    },
                    nested: {
                      SessionDescription: {
                        fields: {
                          type: {
                            type: "Type",
                            id: 1
                          },
                          description: {
                            type: "string",
                            id: 2
                          }
                        },
                        nested: {
                          Type: {
                            values: {
                              UNKNOWN: 0,
                              OFFER: 1,
                              PRANSWER: 2,
                              ANSWER: 3
                            }
                          }
                        }
                      },
                      IceCandidate: {
                        fields: {
                          sdpMid: {
                            type: "string",
                            id: 1
                          },
                          sdpMLineIndex: {
                            type: "int32",
                            id: 2
                          },
                          sdp: {
                            type: "string",
                            id: 3
                          }
                        }
                      },
                      IceCandidateAdd: {
                        fields: {
                          iceCandidate: {
                            rule: "repeated",
                            type: "IceCandidate",
                            id: 1
                          }
                        }
                      },
                      IceCandidateRemoved: {
                        fields: {
                          iceCandidate: {
                            rule: "repeated",
                            type: "IceCandidate",
                            id: 2
                          }
                        }
                      }
                    }
                  },
                  PutMessageRequest: {
                    fields: {
                      message: {
                        type: "Message",
                        id: 1
                      }
                    }
                  },
                  PutMessageResponse: {
                    fields: {
                      message: {
                        type: "Message",
                        id: 1
                      }
                    }
                  },
                  PutMessageError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1,
                          YOU_ARE_TRIED_TO_UPDATE_OTHER_USER_MESSAGE: 2
                        }
                      }
                    }
                  },
                  ChatChannel: {
                    fields: {
                      topic: {
                        type: "string",
                        id: 1
                      },
                      event: {
                        type: "string",
                        id: 2
                      },
                      payload: {
                        type: "ChatPayload",
                        id: 3
                      },
                      reference: {
                        type: "string",
                        id: 4
                      }
                    }
                  },
                  ChatPayload: {
                    oneofs: {
                      messages: {
                        oneof: [
                          "chat"
                        ]
                      }
                    },
                    fields: {
                      chat: {
                        type: "ChatResponses",
                        id: 1
                      }
                    },
                    nested: {
                      ChatResponses: {
                        oneofs: {
                          message: {
                            oneof: [
                              "firstResponse",
                              "newMessage",
                              "updateMessage",
                              "slotEnded"
                            ]
                          }
                        },
                        fields: {
                          firstResponse: {
                            type: "ChatResponse",
                            id: 1
                          },
                          newMessage: {
                            type: "Message",
                            id: 2
                          },
                          updateMessage: {
                            type: "Message",
                            id: 3
                          },
                          slotEnded: {
                            type: "com.newmedia.conference.model.ConnectResponses.SlotEnded",
                            id: 4
                          }
                        }
                      }
                    }
                  },
                  ChatResponse: {
                    fields: {
                      messages: {
                        rule: "repeated",
                        type: "Message",
                        id: 1
                      },
                      nextToken: {
                        type: "string",
                        id: 2
                      }
                    }
                  },
                  ChatError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          YOU_ARE_NOT_IN_CALL: 1
                        }
                      }
                    }
                  },
                  Message: {
                    fields: {
                      messageId: {
                        type: "bytes",
                        id: 1
                      },
                      createdAtMillis: {
                        type: "uint64",
                        id: 2
                      },
                      creatorId: {
                        type: "string",
                        id: 3
                      },
                      bodyType: {
                        type: "bytes",
                        id: 5
                      },
                      deleted: {
                        type: "bool",
                        id: 6
                      }
                    }
                  },
                  HistoryResponse: {
                    fields: {
                      entries: {
                        rule: "repeated",
                        type: "HistoryEntry",
                        id: 1
                      },
                      nextToken: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      HistoryEntry: {
                        fields: {
                          startTimeInMillis: {
                            type: "uint64",
                            id: 1
                          },
                          endTimeInMillis: {
                            type: "uint64",
                            id: 2
                          },
                          title: {
                            type: "string",
                            id: 3
                          },
                          attendeesUserIds: {
                            rule: "repeated",
                            type: "string",
                            id: 4
                          }
                        }
                      }
                    }
                  },
                  CurrentUserResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutUsernameRequest: {
                    fields: {
                      username: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  PutUsernameResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutUsernameUrlError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          EMPTY_USERNAME: 1,
                          INCORRECT_CHARACTER_IN_USERNAME: 2
                        }
                      }
                    }
                  },
                  PutConferencePinRequest: {
                    fields: {
                      conferencePin: {
                        type: "string",
                        id: 1
                      }
                    }
                  },
                  PutConferencePinResponse: {
                    fields: {
                      currentUser: {
                        type: "CurrentUser",
                        id: 1
                      }
                    }
                  },
                  PutConferencePinError: {
                    fields: {
                      code: {
                        type: "Code",
                        id: 1
                      },
                      userMessage: {
                        type: "string",
                        id: 2
                      }
                    },
                    nested: {
                      Code: {
                        values: {
                          UNKNOWN: 0,
                          EMPTY_PIN: 1,
                          INCORRECT_CHARACTER_IN_PIN: 2,
                          PIN_TOO_SHORT: 3,
                          PIN_TOO_LONG: 4
                        }
                      }
                    }
                  },
                  CurrentUser: {
                    fields: {
                      userId: {
                        type: "string",
                        id: 1
                      },
                      name: {
                        type: "string",
                        id: 2
                      },
                      username: {
                        type: "string",
                        id: 3
                      },
                      avatarUrl: {
                        type: "string",
                        id: 7
                      },
                      conferenceUrl: {
                        type: "string",
                        id: 5
                      },
                      conferencePin: {
                        type: "string",
                        id: 6
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  contact: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true
    },
    nested: {
      ContactsRequest: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "DeviceContact",
            id: 1
          }
        },
        nested: {
          DeviceContact: {
            fields: {
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      ContactsResponse: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "ContactMessage",
            id: 1
          },
          users: {
            rule: "repeated",
            type: "user.User",
            id: 2
          }
        },
        nested: {
          ContactMessage: {
            fields: {
              userId: {
                rule: "required",
                type: "string",
                id: 1
              },
              phoneHash: {
                rule: "required",
                type: "string",
                id: 2
              },
              contactName: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      AddContactRequest: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      },
      AddContactResponse: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          }
        }
      }
    }
  },
  user: {
    options: {
      java_package: "com.appunite.user.model",
      java_multiple_files: true,
      optimize_for: "LITE_RUNTIME",
      java_generate_equals_and_hash: true,
      java_outer_classname: "UserModule"
    },
    nested: {
      PresenceMessage: {
        oneofs: {
          presence: {
            oneof: [
              "online",
              "offline",
              "neverSeen"
            ]
          }
        },
        fields: {
          online: {
            type: "Online",
            id: 2
          },
          offline: {
            type: "Offline",
            id: 3
          },
          neverSeen: {
            type: "NeverSeen",
            id: 4
          }
        },
        nested: {
          Online: {
            fields: {}
          },
          Offline: {
            fields: {
              lastSeenInMillis: {
                rule: "required",
                type: "int64",
                id: 1
              }
            }
          },
          NeverSeen: {
            fields: {}
          }
        }
      },
      User: {
        fields: {
          userId: {
            rule: "required",
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          username: {
            type: "string",
            id: 3
          },
          postsCount: {
            type: "int32",
            id: 4
          },
          superuser: {
            type: "Superuser",
            id: 5
          },
          userBio: {
            type: "string",
            id: 6
          },
          avatarUrl: {
            type: "string",
            id: 7
          },
          avatarMainColor: {
            type: "int32",
            id: 8
          },
          privateAccount: {
            type: "bool",
            id: 9,
            options: {
              "default": false
            }
          },
          badgeIds: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          presence: {
            type: "PresenceMessage",
            id: 11
          }
        },
        nested: {
          Superuser: {
            fields: {
              DEPRECATEDWebsiteUrl: {
                type: "string",
                id: 1
              },
              location: {
                type: "string",
                id: 2
              },
              coverUrl: {
                type: "string",
                id: 3
              },
              accountType: {
                type: "string",
                id: 4
              },
              followersCount: {
                type: "int32",
                id: 5
              }
            }
          }
        }
      },
      UserResponse: {
        fields: {
          user: {
            rule: "required",
            type: "user.User",
            id: 1
          }
        }
      }
    }
  },
  protocols: {
    nested: {
      broadcast: {
        nested: {
          Broadcast: {
            fields: {
              username: {
                type: "string",
                id: 1
              },
              pin: {
                type: "string",
                id: 2
              }
            }
          },
          BroadcastStream: {
            fields: {
              broadcastType: {
                type: "Type",
                id: 1
              },
              broadcastUrl: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Type: {
                values: {
                  UNKNOWN: 0,
                  RTSP: 1
                }
              }
            }
          },
          BroadcastSlot: {
            fields: {
              broadcastSlotId: {
                type: "string",
                id: 1
              },
              broadcastChatName: {
                type: "string",
                id: 2
              }
            }
          },
          BroadcastListenersCounter: {
            fields: {
              count: {
                type: "uint32",
                id: 1
              }
            }
          },
          CreateBroadcastSlotRequest: {
            fields: {
              broadcast: {
                type: "Broadcast",
                id: 1
              }
            }
          },
          CreateBroadcastSlotResponse: {
            fields: {
              broadcastSlot: {
                type: "BroadcastSlot",
                id: 1
              }
            }
          },
          CreateBroadcastSlotError: {
            fields: {
              code: {
                type: "Code",
                id: 1
              },
              userMessage: {
                type: "string",
                id: 2
              }
            },
            nested: {
              Code: {
                values: {
                  UNKNOWN: 0,
                  INVALID_PIN: 1
                }
              }
            }
          },
          StartBroadcastRequest: {
            fields: {
              stream: {
                type: "BroadcastStream",
                id: 1
              }
            }
          },
          BroadcastStatusUpdateResponse: {
            fields: {
              stream: {
                type: "BroadcastStream",
                id: 1
              },
              listenersCounter: {
                type: "BroadcastListenersCounter",
                id: 2
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;



//////////////////
// WEBPACK FOOTER
// ./static/proto-bundle.js
// module id = 35
// module chunks = 1